<template>
  <div id="WxBind">
    <el-dialog :center="true" title="微信绑定" :visible.sync="dialogVisible" width="600px">
      <WxQrcodeLogin :operType="operType" :userId="userId" title="" wxDefaultTip="请使用微信扫描二维码绑定"/>
      <div class="eb-button-group">
        <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="dialogVisible = false">关闭</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import WxQrcodeLogin from '@/components/weixin/WxQrcodeLogin';
export default {
  name: 'WxBind',
  components: {
    WxQrcodeLogin
  },
  props: {
    operType: {
      type: String
    }
  },
  data() {
    return {
      dialogVisible: false,
      userId: ''
    };
  },
  created() {
    eventBus.$on('wnBind', userId => {
      this.dialogVisible = true;
      this.userId = userId;
    });
  },
  methods: {},
  beforeDestroy() {
    eventBus.$off('wnBind');
  }
};
</script>
<style scoped lang="less">
</style>
